module.exports = __webpack_public_path__ + "media/images/e-bilet/about/return-ef6ff3f474cafe556cfe5935729c3c8d.svg";